<template>
	<div>
		<div v-if="isLoading" class="spinnerstyle">
			<Spinner />
		</div>
		<div class="login-main-container">
			<div class="h-100 d-flex align-items-center justify-content-center">
				<div class="login-main-sub-container position-relative p-0">
					<b-row class="m-0 w-100">
						<b-col class="p-0">
							<div
								class="w-100 mt-3 d-flex justify-content-center align-items-baseline"
							>
								<!-- <img src="../../assets/newimgs/GREYLOGO.svg" alt="" /> -->
								<img
									src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Logo/SVG/Hire3x_Website_Header.svg"
									style="
                    display: block;
                    visibility: visible;
                    opacity: 1;
                    height: 40px;
                  "
									alt=""
								/>
							</div>
						</b-col>
					</b-row>
					<b-row class="m-0 w-100">
						<b-col class="p-0">
							<div
								class="mt-3 testdetails-container"
								style="padding: 10px; height: calc(100vh - 159px)"
							>
								<div
									class="login-rightcont-headtxt"
									style="border-bottom: 1.5px solid white"
								>
									Install Hire3x Proctoring Agent
								</div>
								<b-row class="mt-3" style="height: 88%">
									<b-col cols="3">
										<div class="xiwin-steps-div">
											<div
												:class="{
													'xi-selected': showStep1Content,
													'xi-unsel pointer': !showStep1Content,
												}"
												class="d-flex p-1"
												@click="step1()"
											>
												<div class="xi-sel-bar"></div>
												<div class="d-flex align-items-center ml-2">
													<div
														:class="{
															'xi-sel-svg-back': showStep1Content,
															'xi-unsel-svg-back': !showStep1Content,
														}"
														class="d-flex align-items-center justify-content-center"
													>
														<img
															:src="
																showStep1Content
																	? require('../../assets/newui-img/extstepblue.svg')
																	: require('../../assets/newimgs/extension/greyStep.svg')
															"
															alt=""
														/>
													</div>
													<div
														:class="{
															'xi-sel-text': showStep1Content,
															'xi-unsel-text': !showStep1Content,
														}"
														class="ml-3"
													>
														Step 1
													</div>
												</div>
											</div>
											<div
												:class="{
													'xi-selected': showStep2Content,
													'xi-unsel pointer': !showStep2Content,
												}"
												class="d-flex p-1 mt-2"
												@click="step2()"
											>
												<div class="xiwin-sel-bar"></div>
												<div class="d-flex align-items-center ml-2">
													<div
														:class="{
															'xi-sel-svg-back': showStep2Content,
															'xi-unsel-svg-back': !showStep2Content,
														}"
														class="d-flex align-items-center justify-content-center"
													>
														<img
															:src="
																showStep2Content
																	? require('../../assets/newui-img/extstepblue.svg')
																	: require('../../assets/newimgs/extension/greyStep.svg')
															"
															alt=""
														/>
													</div>
													<div
														:class="{
															'xi-sel-text': showStep2Content,
															'xi-unsel-text': !showStep2Content,
														}"
														class="ml-3"
													>
														Step 2
													</div>
												</div>
											</div>
											<div class="ext-line-with-text mt-2">
												<div class="ext-line w-100"></div>
												<div class="ext-or-text">OR</div>
												<div class="ext-line w-100"></div>
											</div>
											<div
												class="d-flex p-1 mt-2"
												:class="{
													'xi-selected': showStep3Content,
													'xi-unsel pointer': !showStep3Content,
												}"
												@click="step3()"
											>
												<div class="xi-sel-bar"></div>
												<div class="d-flex align-items-center ml-2">
													<div
														class="xi-unsel-svg-back d-flex align-items-center justify-content-center"
													>
														<img
															src="../../assets/newimgs/extension/extensionvideo.svg"
															alt=""
														/>
													</div>
													<div
														class="ml-3"
														:class="{
															'xi-sel-text': showStep3Content,
															'xi-unsel-text': !showStep3Content,
														}"
													>
														Watch video instruction
													</div>
												</div>
											</div>
										</div>
									</b-col>
									<b-col cols="9" class="p-4">
										<div
											class="d-flex align-items-center justify-content-between xi-head"
										>
											<div class="xi-main-text" v-if="showStep1Content">
												Step 1
											</div>
											<div class="xi-main-text" v-if="showStep2Content">
												Step 2
											</div>
											<div class="xi-main-text" v-if="showStep3Content">
												Watch video instruction
											</div>
											<div class="bluebtns ml-3">
												<!-- use btn name stop checking while the audio is checked -->
												<b-button
													variant="primary"
													class="pl-4 pr-4"
													@click="downloadAgent()"
													>Download Agent</b-button
												>
											</div>
										</div>
										<div class="xi-image-desc" v-if="showStep1Content">
											Click on
											<strong>“Download Agent”</strong>
											button and follow the on-screen steps to install the
											application. You can either open the application from the
											desktop or search for it from the search bar
										</div>
										<div class="xi-image-desc" v-if="showStep2Content">
											Permit access controls and permissions. The application
											will appear in the
											<strong>“System tray”</strong> if it was installed
											correctly. And right-click on the application in the
											System tray and select Start service.
										</div>

										<b-row class="mt-4">
											<b-col cols="10" v-if="showStep1Content">
												<div
													class="d-flex align-items-end justify-content-center"
												>
													<div class="xiwin-image-div">
														<img
															class="h-100 w-100"
															src="../../assets/newimgs/Agent/windowsStep1.png"
															alt=""
														/>
													</div>
													<div class="xiwin-image-div ml-4">
														<img
															class="h-100 w-100"
															src="../../assets/newimgs/Agent/windowsStep2.png"
															alt=""
														/>
													</div>
												</div>
											</b-col>
											<b-col cols="10" v-if="showStep2Content">
												<div
													class="d-flex align-items-end justify-content-center"
												>
													<div class="xiwin-image-div">
														<img
															class="h-100 w-100"
															src="../../assets/newimgs/Agent/windowsStep3.png"
															alt=""
														/>
													</div>
												</div>
											</b-col>
											<b-col cols="12" v-if="showStep3Content">
												<div style="height: calc(100vh - 350px)">
													<iframe
														title="Windows Process Video"
														:src="'https://www.youtube.com/embed/PO0IIV_pYdE'"
														allowfullscreen
														class="w-100 h-100"
													></iframe>
												</div>
											</b-col>
											<b-col cols="2">
												<div
													class="d-flex align-items-end justify-content-end h-100"
												>
													<div v-if="showStep1Content">
														<img
															src="../../assets/newimgs/extension/disableLeft.svg"
															alt=""
														/>
													</div>
													<div v-else-if="showStep2Content">
														<img
															@click="step1()"
															class="mr-4 pointer"
															src="../../assets/newimgs/extension/activeLeft.svg"
															alt=""
														/>
													</div>
													<div
														v-if="
															showStep2Content == false &&
																showStep3Content == false
														"
													>
														<img
															@click="step2()"
															class="pointer ml-4"
															src="../../assets/newimgs/extension/activeRight.svg"
															alt=""
														/>
													</div>
													<div v-else-if="showStep3Content == false">
														<img
															src="../../assets/newimgs/extension/disableRight.svg"
															alt=""
														/>
													</div>
												</div>
											</b-col>
										</b-row>
									</b-col>
								</b-row>
							</div>
							<hr class="mb-0" />
							<div
								class="p-3 d-flex align-items-center justify-content-between bluebtns"
							>
								<b-button
									variant="outline-primary"
									@click="$bvModal.show('leavetestmodal')"
									>Leave Test</b-button
								>
								<b-button
									v-if="!verifyAgent"
									variant="primary"
									class="pl-4 pr-4"
									@click="verifyFunc()"
									>Verify Agent</b-button
								>
								<div v-if="verifyAgent">
									<b-button
										variant="primary"
										class="pl-4 pr-4"
										v-if="testDetails.config.allowImageAndIdCapture"
										@click="nextSelfiePage()"
										>Continue</b-button
									>
									<b-button
										variant="primary"
										class="pl-4 pr-4"
										v-else-if="testDetails.config.typingTest"
										@click="goToTypingTest()"
										>Continue</b-button
									>
									<b-button
										variant="primary"
										class="pl-4 pr-4"
										v-else-if="testDetails.config.communicationTest"
										@click="goTocommunicationTest()"
										>Continue</b-button
									>
									<b-button
										variant="primary"
										class="pl-4 pr-4"
										v-else
										@click="nextdosanddonts()"
										>Continue</b-button
									>
								</div>
							</div>
						</b-col>
					</b-row>
				</div>
				<b-modal
					id="leavetestmodal"
					size="md"
					centered
					hide-footer
					hide-header
					no-close-on-backdrop
					:no-close-on-esc="true"
				>
					<div
						class="newmodalheadings mt-3 d-flex align-items-center justify-content-center"
					>
						Alert !
					</div>
					<div
						@click="$bvModal.hide('leavetestmodal')"
						class="modalcloseicon pointer"
					>
						<img
							class="rotate-on-hover"
							src="../../assets/newimgs/closeicon.svg"
							alt=""
						/>
					</div>
					<div
						class="d-flex flex-column align-items-center justify-content-center mt-4 mb-4"
					>
						<div>
							<img src="../../assets/newui-img/leavetest.svg" alt="" />
						</div>
						<div class="newui-modal-header mt-4">
							Are you sure you want to leave the test ?
						</div>
						<div class="newui-modal-bodytxt mt-3">
							Please note this action cannot be undone
						</div>
						<div class="bluebtns mt-5">
							<b-button
								class="mr-3 pl-4 pr-4"
								variant="outline-primary"
								@click="$bvModal.hide('leavetestmodal')"
								>Cancel</b-button
							>
							<b-button
								variant="primary"
								class="pl-4 pr-4"
								@click="leaveThetest()"
								>Leave Test</b-button
							>
						</div>
					</div>
				</b-modal>
			</div>
		</div>
		<b-modal id="extensionmodal" centered hide-footer hide-header size="md">
			<div
				class="newmodalheadings mt-4 d-flex align-items-center justify-content-center"
			>
				Please install Hire3x proctoring Agent
			</div>
			<div
				@click="$bvModal.hide('extensionmodal')"
				class="modalcloseicon pointer"
			>
				<img src="../../assets/newimgs/closeicon.svg" alt="" />
			</div>
			<div class="typingtest-completed-txt mt-5 pl-4 pr-4">
				<!-- Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut fringilla
        magna porta vel auctor. -->
			</div>
			<div class="mt-5 d-flex justify-content-center">
				<img src="../../assets/newimgs/extension/modalSvg.svg" alt="" />
			</div>
			<div class="d-flex justify-content-center mt-5 mb-4">
				<div class="bluebtns">
					<!-- use btn name stop checking while the audio is checked -->
					<b-button variant="primary" @click="downloadAgent()"
						>Install</b-button
					>
				</div>
			</div>
		</b-modal>
		<CheckAgentModal />
		<AgentIssue />
		<VmModal />
		<DeviceConnected />
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { downloadAgent } from "../../apiFunction";
import agentMacWinLinux from "../../mixins/agentMacWinLinux.js";

export default {
	name: "SystemCheck",
	mixins: [agentMacWinLinux],
	data() {
		return {
			isLoading: false,
			verifyExtension: false,
			showStep1Content: false,
			showStep2Content: false,
			showStep3Content: false,
			verifyAgent: false,
		};
	},

	props: {
		NavigateWindow: Boolean,
	},
	created() {
		console.log("Window Page", this.NavigateWindow);
		this.showStep1Content = true;
	},
	computed: {
		...mapGetters("sectionVUEX", {
			testDetails: "getTestDetails",
			uuid: "getUUID",
		}),
	},
	methods: {
		step1() {
			this.showStep3Content = false;
			this.showStep2Content = false;
			this.showStep1Content = true;
		},
		step2() {
			this.showStep1Content = false;
			this.showStep3Content = false;
			this.showStep2Content = true;
		},
		step3() {
			this.showStep1Content = false;
			this.showStep2Content = false;
			this.showStep3Content = true;
		},

		async downloadAgent() {
			const res = await downloadAgent("windows");
			if (res.status == 200) {
				this.downloadAgentBtn(res.data.data[0].downloadLink);
			}
		},
		downloadAgentBtn(item) {
			window.open(item);
		},
	},
};
</script>

<style scoped>
.xiwin-steps-div {
	background-color: #ffffff;
	border-radius: 8px;
	height: calc(100vh - 250px);
	overflow: auto;
	padding: 15px;
}

.xiwin-selected {
	background-color: #4c78ce;
	border-radius: 8px;
}

.xiwin-unsel {
	background-color: #dbe7ff;
	border-radius: 8px;
}

.xiwin-sel-bar {
	background-color: #ffffff;
	border-radius: 8px;
	width: 3px;
	height: 45px;
}

.xiwin-sel-svg-back {
	background-color: #ffffff;
	border-radius: 50%;
	width: 30px;
	height: 30px;
	border: 1px solid #4c78ce;
}

.xiwin-unsel-svg-back {
	background-color: #ffffff;
	border-radius: 50%;
	width: 30px;
	height: 30px;
	border: 1px solid #707070;
}

.xiwin-sel-text {
	color: #ffffff;
	font-size: 16px;
	font-weight: 600;
}

.xiwin-unsel-text {
	color: #454545;
	font-size: 14px;
	font-weight: 500;
}

.xiwin-alert-div {
	border: 1px solid #4c78ce;
	padding: 15px;
	border-radius: 8px;
	background-color: #ffffff;
}

.xiwin-refresh {
	color: #4c78ce;
	font-size: 13px;
	font-weight: 600;
	text-decoration-line: underline;
}

.xiwin-main-text {
	color: #333333;
	font-size: 18px;
	font-weight: 600;
}

.xiwin-head {
	padding-bottom: 15px;
	border-bottom: 1.5px solid white;
}

.xiwin-image-desc {
	color: black;
	font-weight: 500;
	font-size: 16px;
}

.xiwin-image-div {
	height: calc(100vh - 400px);
}
</style>

<style scoped>
.xi-warningbox-txt {
	font-family: "Montserrat", sans-serif;
	font-weight: 600;
	font-size: 13px;
	color: #333333;
}
.xi-steps-div {
	background-color: #ffffff;
	border-radius: 8px;
	height: calc(100vh - 400px);
	padding: 15px;
}

.xi-selected {
	background-color: #20639b;
	border-radius: 8px;
}

.xi-unsel {
	background: #ffffff;
	border: 1px solid rgba(140, 140, 140, 0.33);
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.17);
	border-radius: 8px;
}

.xi-sel-bar {
	background-color: #ffffff;
	border-radius: 8px;
	width: 1px;
	height: 45px;
}

.xi-sel-svg-back {
	background-color: #ffffff;
	border-radius: 50%;
	width: 30px;
	height: 30px;
	border: 1px solid #4c78ce;
}

.xi-unsel-svg-back {
	background-color: #eef3f7;
	border-radius: 50%;
	width: 30px;
	height: 30px;
}

.xi-sel-text {
	font-family: "Montserrat", sans-serif;
	font-weight: 600;
	font-size: 14px;
	color: #ffffff;
}

.xi-unsel-text {
	font-family: "Montserrat", sans-serif;
	font-weight: 500;
	font-size: 14px;
	color: #333333;
}

.xi-alert-div {
	background: #ffffff;
	border: 0.8px solid rgba(140, 140, 140, 0.45);
	box-shadow: 0px 15px 30px rgba(122, 122, 122, 0.2);
	border-radius: 8px;
	padding: 15px;
	height: 125px;
}

.xi-refresh {
	font-family: "Montserrat", sans-serif;
	font-weight: 600;
	font-size: 13px;
	color: #20639b;
}

.xi-main-text {
	font-family: "Montserrat", sans-serif;
	font-weight: 600;
	font-size: 18px;
	color: #333333;
}

.xi-head {
	padding-bottom: 15px;
	/* border-bottom: 1.5px solid white; */
}

.xi-image-desc {
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	color: #333333;
}

.xi-image-div {
	height: calc(100vh - 400px);
}
</style>
